import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'checkout-retailer_initiate_checkout-click';
/**
 * Track when retailer user initiate checkout
 */
export function trackCheckoutRetailerInitiateCheckoutClick(currency, cartValue2, retailer_token3, pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'InitiateCheckout',
        googleTagManagerEvent: 'InitiateCheckout',
        pixelCustomDataParams: pixelCustomDataParams,
        parameters: { currency, cartValue2, retailer_token3 },
    });
}
